import { useState, useEffect, useRef } from "react";
import { usePage } from "@inertiajs/react";
import * as Icon from "@phosphor-icons/react/dist/ssr";
import ModalCarrito from "../modal/ModalCarrito";
import Search from "../modal/search";

import { InertiaProps, SubSeccion } from "@/types/app";
import { useNavbarStore } from "../../stores/useNavbar";
import { useLoginModal } from "../../stores/useLoginModal";
import { useModalProvider } from "../../stores/useModalProvider";
import { useSearchModal } from "../../stores/useSearchProvider";
import { useCartStore } from "../../stores/useCart";
import { IoIosSearch } from "react-icons/io";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { FaShoppingCart } from "react-icons/fa";
import { HiOutlineShoppingBag } from "react-icons/hi2";
import { BsCart3 } from "react-icons/bs";
import { IoBagHandleOutline } from "react-icons/io5";
import { CiLocationOn } from "react-icons/ci";
import { PiHandCoinsThin } from "react-icons/pi";
import { usePointsStore } from "@/stores/usePointsStore";
import { LuUser2 } from "react-icons/lu";
import DropdownNav from "../megaMenu/dropdownnav";
import { Cake, Palette, Wrench, Gift, IceCream, Coffee, ChevronLeft, ChevronRight, Award } from "lucide-react";
import { getImageUrl, separadorMiles } from "@/utils/global";

const nav = () => {
    const { navbar, cart, navPersonalizados, user, puntos, agregadosRecientemente, masVendidos } =
        usePage<InertiaProps>().props;
    const pathname = decodeURIComponent(window.location.pathname);
    const { isLoginModalOpen, toggleLoginModal, closeLoginModal } =
        useLoginModal();
    const { isOpenNavbar, toggleNavbar } = useNavbarStore();
    const [openSubNavMobile, setOpenSubNavMobile] = useState<number | null>(
        null
    );
    const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const scrollRefMasVendidos = useRef<HTMLDivElement>(null);

    const scroll = (
        ref: React.RefObject<HTMLDivElement>,
        direction: "left" | "right"
    ) => {
        if (ref.current) {
            const scrollAmount = 160; // Reducido para tarjetas más pequeñas
            ref.current.scrollBy({
                left: direction === "left" ? -scrollAmount : scrollAmount,
                behavior: "smooth",
            });
        }
    };
    const { openModal } = useModalProvider();
    const { productos, setCart } = useCartStore();
    const { openSearchModal } = useSearchModal();
    const { establecerPuntos } = usePointsStore();

    const handleOpenSubNavMobile = (index: number) => {
        setOpenSubNavMobile(openSubNavMobile === index ? null : index);
    };

    const [fixedHeader, setFixedHeader] = useState(false);
    const [lastScrollPosition, setLastScrollPosition] = useState(0);

    const dividirEnPartes = (arr: Array<SubSeccion>, tamanoParte: number) => {
        const partes = [];
        const copiaArray = [...arr];

        copiaArray.sort((a, b) => {
            if (a.nombre < b.nombre) {
                return -1;
            }
            if (a.nombre > b.nombre) {
                return 1;
            }
            return 0;
        });

        for (let i = 0; i < copiaArray.length; i += tamanoParte) {
            partes.push(copiaArray.slice(i, i + tamanoParte));
        }

        return partes;
    };

    const getCategoryIcon = (categoryName: string) => {
        const name = categoryName.toLowerCase();
        if (name.includes('torta')) return <Cake className="w-6 h-6 text-[#790546]" />;
        if (name.includes('diseño')) return <Palette className="w-6 h-6 text-[#790546]" />;
        if (name.includes('personalizada')) return <Wrench className="w-6 h-6 text-[#790546]" />;
        if (name.includes('cotillón') || name.includes('regalo')) return <Gift className="w-6 h-6 text-[#790546]" />;
        if (name.includes('kuchen') || name.includes('semi')) return <IceCream className="w-6 h-6 text-[#790546]" />;
        if (name.includes('desayuno')) return <Coffee className="w-6 h-6 text-[#790546]" />;
        return <Cake className="w-6 h-6 text-[#790546]" />;
    };

    const getSubmenuIcon = (submenuName: string) => {
        const name = submenuName.toLowerCase();
        // Iconos más específicos y apropiados
        if (name.includes('express')) return <Coffee className="w-4 h-4 text-[#790546]" />;
        if (name.includes('helada') || name.includes('fría')) return <IceCream className="w-4 h-4 text-[#790546]" />;
        if (name.includes('reina') || name.includes('especial')) return <Award className="w-4 h-4 text-[#790546]" />;
        if (name.includes('hojarasca') || name.includes('hoja')) return <Cake className="w-4 h-4 text-[#790546]" />;
        if (name.includes('sabor') || name.includes('sabores')) return <Palette className="w-4 h-4 text-[#790546]" />;
        if (name.includes('diseño') || name.includes('diseños')) return <Palette className="w-4 h-4 text-[#790546]" />;
        if (name.includes('personalizada')) return <Wrench className="w-4 h-4 text-[#790546]" />;
        if (name.includes('cotillón') || name.includes('regalo')) return <Gift className="w-4 h-4 text-[#790546]" />;
        if (name.includes('kuchen') || name.includes('semi')) return <IceCream className="w-4 h-4 text-[#790546]" />;
        if (name.includes('desayuno')) return <Coffee className="w-4 h-4 text-[#790546]" />;
        if (name.includes('coctelería') || name.includes('cocteleria')) return <Coffee className="w-4 h-4 text-[#790546]" />;
        // Si no coincide con nada específico, no mostrar icono
        return null;
    };


    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            setFixedHeader(
                scrollPosition > 0 && scrollPosition < lastScrollPosition
            );
            setLastScrollPosition(scrollPosition);
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollPosition]);

    // Prevenir scroll del body cuando el menú móvil está abierto
    useEffect(() => {
        if (isOpenNavbar) {
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                document.body.style.overflow = '';
                window.scrollTo(0, scrollY);
            };
        }
    }, [isOpenNavbar]);

    // Cerrar dropdown del usuario cuando se hace clic fuera
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Element;
            if (isUserDropdownOpen && !target.closest('.user-dropdown')) {
                setIsUserDropdownOpen(false);
            }
        };

        if (isUserDropdownOpen) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isUserDropdownOpen]);

    useEffect(() => {
        const modal = document.querySelector(".loginModalClass");
        const handleClickOutside = (event: MouseEvent) => {
            if (modal && !modal.contains(event.target as Node)) {
                if (isLoginModalOpen === true) {
                    closeLoginModal();
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        // Manejar el scroll del body
        if (isLoginModalOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.body.style.overflow = "unset";
        };
    }, [isLoginModalOpen]);

    useEffect(() => {
        setCart(cart);
        // Los puntos se establecen en el store pero NO se muestran en el navbar
        // Los puntos se muestran únicamente en el perfil del usuario (aside.tsx)
        establecerPuntos(puntos);
    }, []);

    return (
        <>
            <>
                <div
                    className={`header-menu style-one ${fixedHeader ? " fixed" : "relative"
                        } w-full md:h-[74px] h-[56px] bg-white`}
                >
                    <ModalCarrito />
                    <Search />

                    <div className="px-2 xs:px-3 sm:px-4 md:px-6 mx-auto h-full">
                        {/* HEADER GRID PARA DESKTOP */}
                        <div className="header-main grid grid-cols-3 items-center h-full relative">
                            {/* Izquierda: Productos o menú hamburguesa en móvil */}
                            <div className="flex items-center gap-4 sm:gap-6 md:gap-8">
                                {/* Menú móvil visible solo en móviles */}
                                <div
                                    className="menu-mobile-icon xl:hidden flex items-center cursor-pointer group relative menu-mobile-subtle"
                                    onClick={toggleNavbar}
                                >
                                    {/* Botón cuadrado con pastel + texto */}
                                    <div className="relative z-10 inline-flex items-center gap-1.5 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 rounded-md bg-white border border-[#790546]/25 text-[#790546] shadow-sm transition-all duration-300 group-hover:bg-[#790546] group-hover:text-white group-hover:shadow-md align-middle">
                                        <Cake className="w-4 h-4 inline-block align-middle" />
                                        <span className="text-xs font-semibold tracking-wide inline-block align-middle leading-none">Productos</span>
                                    </div>
                                </div>
                                {/* Productos solo en desktop */}
                                <div className="hidden xl:flex items-center gap-8">
                                    <DropdownNav
                                        navbar={navbar}
                                        navPersonalizados={navPersonalizados}
                                    />
                                </div>
                            </div>

                            {/* Centro: Logo siempre centrado */}
                            <div className="flex justify-center">
                                <a href="/" className="flex items-center">
                                    <div className="font-[StoneStick] heading4 text-[#790546] text-[20px] xs:text-[24px] sm:text-[26px] md:text-[28px] lg:text-[32px] xl:text-[36px] 2xl:text-[40px] whitespace-nowrap -ml-6 xs:-ml-8 sm:-ml-10 md:-ml-12 lg:-ml-14 xl:-ml-16">
                                        Patty Cariño
                                    </div>
                                </a>
                            </div>

                            {/* Derecha: Acciones */}
                            <div className="flex items-center gap-2 xs:gap-3 sm:gap-6 md:gap-8 xl:gap-12 justify-end pr-1 xs:pr-2 sm:pr-0">
                                <div className="search-icon flex flex-col items-center cursor-pointer relative">
                                    <IoIosSearch
                                        size={20}
                                        color="black"
                                        onClick={openSearchModal}
                                    />
                                    <div className="line absolute bg-line w-px h-6 -right-3 xs:-right-4 xl:-right-6"></div>
                                </div>
                                <div className="list-action flex items-center gap-2 xs:gap-3 xl:gap-4">
                                    {/* user deslogueado*/}
                                    {user === null && (
                                        <>
                                            {/* Overlay oscuro para móviles */}
                                            {isLoginModalOpen && (
                                                <div className="fixed inset-0 bg-black bg-opacity-80 z-[9998] md:hidden"></div>
                                            )}

                                            <div className="user-icon flex flex-col items-center justify-center cursor-pointer relative p-1 xs:p-2">
                                                <div className="relative w-7 h-7 xs:w-8 xs:h-8 flex items-center justify-center">
                                                    <LuUser2
                                                        size={18}
                                                        color="black"
                                                        onClick={toggleLoginModal}
                                                    />
                                                </div>
                                                <span
                                                    className="text-xs text-gray-600 mt-1 hidden md:block cursor-pointer hover:text-[#790546] transition-colors duration-200"
                                                    onClick={toggleLoginModal}
                                                >
                                                    Perfil
                                                </span>

                                                <div
                                                    className={`login-popup absolute top-[74px] right-0 w-[380px] p-0 rounded-2xl bg-white shadow-2xl overflow-hidden
                    ${isLoginModalOpen ? "open" : ""} loginModalClass`}
                                                >
                                                    {/* Fondo decorativo */}
                                                    <div
                                                        className="absolute inset-0 opacity-5"
                                                        style={{
                                                            backgroundImage: `url(${getImageUrl("/images/patrones/fondo%20test.png")})`,
                                                            backgroundSize: 'cover',
                                                            backgroundPosition: 'center',
                                                            backgroundRepeat: 'no-repeat'
                                                        }}
                                                    ></div>

                                                    {/* Botón de cerrar */}
                                                    <div className="close-btn absolute top-4 right-4 z-20">
                                                        <div
                                                            className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
                                                            onClick={toggleLoginModal}
                                                        >
                                                            <Icon.X size={16} />
                                                        </div>
                                                    </div>

                                                    {/* Contenido del modal */}
                                                    <div className="relative z-10 p-8">
                                                        {/* Header */}
                                                        <div className="text-center mb-6">
                                                            <h3 className="text-2xl font-bold text-[#790546] mb-2">
                                                                ¡Bienvenid@! 🎉
                                                            </h3>
                                                            <p className="text-gray-600 text-sm">
                                                                Accede a tu cuenta o crea una nueva
                                                            </p>
                                                        </div>

                                                        {/* Botón de Login */}
                                                        <a
                                                            href={`${window.origin}/auth/login`}
                                                            className="block w-full bg-gradient-to-r from-[#790546] to-[#9a0a5a] text-white py-4 px-6 rounded-xl font-bold text-center hover:from-[#9a0a5a] hover:to-[#790546] hover:scale-105 transition-all duration-300 shadow-lg mb-4"
                                                        >
                                                            🚀 Ingresar a mi cuenta
                                                        </a>

                                                        {/* Separador */}
                                                        <div className="flex items-center my-6">
                                                            <div className="flex-1 border-t border-gray-200"></div>
                                                            <span className="px-4 text-gray-500 text-sm">o</span>
                                                            <div className="flex-1 border-t border-gray-200"></div>
                                                        </div>

                                                        {/* Botón de Registro */}
                                                        <div className="text-center mb-6">
                                                            <p className="text-gray-600 text-sm mb-3">
                                                                ¿No tienes cuenta?
                                                            </p>
                                                            <a
                                                                href={`${window.origin}/auth/register`}
                                                                className="inline-block w-full bg-white border-2 border-[#790546] text-[#790546] py-3 px-6 rounded-xl font-bold text-center hover:bg-[#790546] hover:text-white hover:scale-105 transition-all duration-300 shadow-md"
                                                            >
                                                                ✨ Crear mi cuenta
                                                            </a>
                                                        </div>

                                                        {/* Beneficios rápidos */}
                                                        <div className="space-y-2 mb-6">
                                                            <div className="flex items-center text-xs text-gray-600">
                                                                <span className="mr-2">🎂</span>
                                                                <span>Productos exclusivos</span>
                                                            </div>
                                                            <div className="flex items-center text-xs text-gray-600">
                                                                <span className="mr-2">💰</span>
                                                                <span>Ofertas especiales</span>
                                                            </div>
                                                            <div className="flex items-center text-xs text-gray-600">
                                                                <span className="mr-2">🚚</span>
                                                                <span>Envíos rápidos</span>
                                                            </div>
                                                        </div>

                                                        {/* Soporte */}
                                                        <div className="text-center pt-4 border-t border-gray-100">
                                                            <p className="text-xs text-gray-500 mb-2">¿Necesitas ayuda?</p>
                                                            <a
                                                                href="mailto:soporte@pattycarino.cl"
                                                                className="text-[#790546] hover:underline text-sm font-medium"
                                                            >
                                                                soporte@pattycarino.cl
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {/* user logueado*/}
                                    {user !== null && (
                                        <>
                                            {/* Overlay oscuro para móviles */}
                                            {isLoginModalOpen && (
                                                <div className="fixed inset-0 bg-black bg-opacity-80 z-[9998] md:hidden"></div>
                                            )}

                                            <div className="user-icon flex flex-col items-center justify-center cursor-pointer relative p-1 xs:p-2">
                                                <div
                                                    className="w-7 h-7 xs:w-8 xs:h-8 bg-[#790546] rounded-full flex items-center justify-center relative"
                                                    onClick={toggleLoginModal}
                                                >
                                                    <span className="text-white font-bold text-sm">
                                                        {user.nombre?.charAt(0) || 'U'}{user.apellido?.charAt(0) || ''}
                                                    </span>

                                                    {/* Badge con estrella dorada - solo si hay puntos */}
                                                    {puntos > 0 && (
                                                        <div className="absolute -top-1 -right-1 w-5 h-5 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center shadow-lg animate-pulse">
                                                            <span className="text-white text-xs font-bold">⭐</span>
                                                        </div>
                                                    )}
                                                </div>
                                                <span
                                                    className="text-xs text-gray-600 mt-1 hidden md:block cursor-pointer hover:text-[#790546] transition-colors duration-200"
                                                    onClick={toggleLoginModal}
                                                >
                                                    Perfil
                                                </span>

                                                <div
                                                    className={`login-popup absolute top-[74px] right-0 w-[380px] p-0 rounded-2xl bg-white shadow-2xl overflow-hidden
                    ${isLoginModalOpen ? "open" : ""} loginModalClass`}
                                                >
                                                    {/* Fondo decorativo con pasteles */}
                                                    <div
                                                        className="absolute inset-0 opacity-10"
                                                        style={{
                                                            backgroundImage: `url(${getImageUrl("/images/patrones/fondo%20test.png")})`,
                                                            backgroundSize: 'cover',
                                                            backgroundPosition: 'center',
                                                            backgroundRepeat: 'no-repeat',
                                                            filter: 'brightness(0) invert(1)'
                                                        }}
                                                    ></div>

                                                    {/* Ilustraciones decorativas */}
                                                    <div className="absolute top-4 right-4 text-4xl opacity-20">🍰</div>
                                                    <div className="absolute bottom-4 left-4 text-3xl opacity-20">🧁</div>
                                                    <div className="absolute top-1/2 right-2 text-2xl opacity-15">🍪</div>

                                                    {/* Botón de cerrar para móviles */}
                                                    <div className="close-mobile-btn absolute top-4 right-4 z-20 md:hidden">
                                                        <div
                                                            className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
                                                            onClick={toggleLoginModal}
                                                        >
                                                            <Icon.X size={20} />
                                                        </div>
                                                    </div>

                                                    {/* Contenido del modal */}
                                                    <div className="relative z-10 p-8">
                                                        {/* Header */}
                                                        <div className="text-center mb-6">
                                                            <div className="w-16 h-16 bg-[#790546] rounded-full flex items-center justify-center mx-auto mb-3">
                                                                <span className="text-white font-bold text-xl">
                                                                    {user.nombre?.charAt(0) || 'U'}{user.apellido?.charAt(0) || ''}
                                                                </span>
                                                            </div>
                                                            <h3 className="text-xl font-bold text-[#790546] mb-1">
                                                                ¡Hola, {user.nombre}! 👋
                                                            </h3>
                                                            <p className="text-gray-600 text-sm mb-3">
                                                                Gestiona tu cuenta y pedidos
                                                            </p>
                                                            {/* Puntos del usuario */}
                                                            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#790546]/10 to-[#790546]/5 px-4 py-2 rounded-full border border-[#790546]/20">
                                                                <PiHandCoinsThin className="w-4 h-4 text-[#790546]" />
                                                                <span className="font-bold text-[#790546] text-sm">
                                                                    {separadorMiles(puntos)} CariñoPoints
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* Opciones del menú */}
                                                        <div className="space-y-3 mb-6">
                                                            <a
                                                                href={`${window.origin}/profile`}
                                                                className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors duration-200 border border-gray-200"
                                                            >
                                                                <LuUser2 className="w-5 h-5 text-[#790546]" />
                                                                <div>
                                                                    <p className="font-medium text-gray-800">Mi cuenta</p>
                                                                    <p className="text-xs text-gray-500">Ver perfil</p>
                                                                </div>
                                                            </a>
                                                            <a
                                                                href={`${window.origin}/profile/myorders`}
                                                                className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors duration-200 border border-gray-200"
                                                            >
                                                                <IoBagHandleOutline className="w-5 h-5 text-[#790546]" />
                                                                <div>
                                                                    <p className="font-medium text-gray-800">Mis compras</p>
                                                                    <p className="text-xs text-gray-500">Historial de pedidos</p>
                                                                </div>
                                                            </a>
                                                            <a
                                                                href={`${window.origin}/profile/address`}
                                                                className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors duration-200 border border-gray-200"
                                                            >
                                                                <CiLocationOn className="w-5 h-5 text-[#790546]" />
                                                                <div>
                                                                    <p className="font-medium text-gray-800">Mis direcciones</p>
                                                                    <p className="text-xs text-gray-500">Gestionar ubicaciones</p>
                                                                </div>
                                                            </a>
                                                            <a
                                                                href={`${window.origin}/profile/mypoints`}
                                                                className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors duration-200 border border-gray-200"
                                                            >
                                                                <PiHandCoinsThin className="w-5 h-5 text-[#790546]" />
                                                                <div>
                                                                    <p className="font-medium text-gray-800">Mis puntos</p>
                                                                    <p className="text-xs text-gray-500">Ver puntos disponibles</p>
                                                                </div>
                                                            </a>
                                                        </div>

                                                        {/* Botón de logout */}
                                                        <a
                                                            href={`${window.origin}/api/auth/logout`}
                                                            className="block w-full bg-[#790546] text-white py-3 px-4 rounded-xl font-semibold text-center hover:bg-[#9a0a5a] hover:scale-105 transition-all duration-300 shadow-lg"
                                                        >
                                                            🚪 Cerrar Sesión
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    <div
                                        className="cart-icon flex flex-col items-center relative cursor-pointer p-1 xs:p-2"
                                        onClick={openModal}
                                    >
                                        <div className="relative w-7 h-7 xs:w-8 xs:h-8 flex items-center justify-center">
                                            <BsCart3
                                                size={18}
                                                color={productos.length > 0 ? "#790546" : "black"}
                                            />
                                            {productos.length > 0 && (
                                                <span className="quantity cart-quantity absolute -right-1 -top-1 text-xs text-white bg-[#790546] w-5 h-5 flex items-center justify-center rounded-full cart-badge-bounce shadow-lg">
                                                    {productos.length}
                                                </span>
                                            )}
                                        </div>
                                        <span className="text-xs text-gray-600 mt-1 hidden md:block">Carrito</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>

            <div id="menu-mobile" className={`${isOpenNavbar ? "open" : ""}`}>
                <div className="menu-container bg-white h-full w-full">
                    <div className="h-full w-full">
                        <div
                            className="menu-main h-full overflow-y-auto overflow-x-hidden scrollbar-hide w-full"
                            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                            onWheel={(e) => {
                                e.stopPropagation();
                                const element = e.currentTarget;
                                const { scrollTop, scrollHeight, clientHeight } = element;
                                const isScrollingDown = e.deltaY > 0;
                                const isScrollingUp = e.deltaY < 0;

                                if (isScrollingDown && scrollTop + clientHeight >= scrollHeight) {
                                    e.preventDefault();
                                } else if (isScrollingUp && scrollTop <= 0) {
                                    e.preventDefault();
                                }
                            }}
                        >
                            <div className="heading py-6 relative flex items-center justify-center border-b border-gray-100">
                                <div
                                    className="close-menu-mobile-btn absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors"
                                    onClick={toggleNavbar}
                                >
                                    <Icon.X size={20} />
                                </div>
                                <a
                                    href={"/"}
                                    className="text-3xl font-[StoneStick] text-[#790546] font-bold"
                                    onClick={toggleNavbar}
                                >
                                    Patty Cariño
                                </a>
                            </div>

                            {/* Carousel de productos más vendidos - versión compacta */}
                            <div className="featured-products px-4 py-4 bg-gray-50">
                                <div className="flex items-center gap-2 mb-3">
                                    <Award className="w-5 h-5 text-[#790546]" />
                                    <h3 className="text-base font-semibold text-[#790546]">Más Comprados</h3>
                                </div>

                                <div className="relative">
                                    <button
                                        onClick={() => scroll(scrollRefMasVendidos, "left")}
                                        className="absolute left-1 top-1/2 -translate-y-1/2 z-10 bg-white border border-gray-200 hover:bg-gray-50 text-[#790546] p-1.5 rounded-full hover:shadow-md transition-all duration-300 flex items-center justify-center"
                                    >
                                        <ChevronLeft className="w-3 h-3" />
                                    </button>

                                    <button
                                        onClick={() => scroll(scrollRefMasVendidos, "right")}
                                        className="absolute right-1 top-1/2 -translate-y-1/2 z-10 bg-white border border-gray-200 hover:bg-gray-50 text-[#790546] p-1.5 rounded-full hover:shadow-md transition-all duration-300 flex items-center justify-center"
                                    >
                                        <ChevronRight className="w-3 h-3" />
                                    </button>

                                    <div
                                        ref={scrollRefMasVendidos}
                                        className="flex gap-3 overflow-x-auto scrollbar-hide pb-2 scroll-smooth px-6"
                                        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                                    >
                                        {masVendidos && masVendidos.length > 0 ? (
                                            masVendidos.slice(0, 4).map((product: any, index: number) => (
                                                <div key={product.id + "-" + index} className="flex-shrink-0">
                                                    <a href={product.es_individual == 0
                                                        ? `/producto/${product.nombre}`
                                                        : `/producto/${product.nombre}/${product.sabor || ""}`}
                                                        className="block">
                                                        <div className="bg-white rounded-lg p-3 shadow-sm hover:shadow-md transition-shadow min-w-[140px] max-w-[140px]">
                                                            <div className="aspect-square bg-gray-100 rounded-lg mb-2 flex items-center justify-center">
                                                                <img
                                                                    src={getImageUrl(product.imagen || "")}
                                                                    alt={product.nombre}
                                                                    className="w-full h-full object-cover rounded-lg"
                                                                    onError={(e) => {
                                                                        e.currentTarget.style.display = 'none';
                                                                        const nextElement = e.currentTarget.nextElementSibling as HTMLElement;
                                                                        if (nextElement) {
                                                                            nextElement.style.display = 'flex';
                                                                        }
                                                                    }}
                                                                />
                                                                <div className="hidden w-full h-full items-center justify-center">
                                                                    <Cake className="w-6 h-6 text-gray-400" />
                                                                </div>
                                                            </div>
                                                            <p className="text-xs font-medium text-gray-800 truncate">
                                                                {"nombre_sabor" in product && product.nombre_sabor
                                                                    ? product.nombre_sabor
                                                                    : product.sabor || product.nombre}
                                                            </p>
                                                            <p className="text-xs text-gray-500">${separadorMiles(product.precio)}</p>
                                                        </div>
                                                    </a>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="flex items-center justify-center w-full py-8">
                                                <p className="text-gray-500 text-sm">No hay productos disponibles</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="list-nav mt-4">
                                <ul className="px-4">
                                    {navbar.map((item, index) => (
                                        <li
                                            key={item.seccion.id}
                                            className="border-b border-gray-100"
                                        >
                                            {/* Nuevo diseño simple */}
                                            <div className="py-4">
                                                <div
                                                    className="flex items-center justify-between cursor-pointer hover:bg-gray-50 rounded-lg p-3 transition-colors"
                                                    onClick={() =>
                                                        handleOpenSubNavMobile(
                                                            index + 1
                                                        )
                                                    }
                                                >
                                                    <div className="flex items-center gap-3">
                                                        {getCategoryIcon(item.seccion.nombre)}
                                                        <span className="text-lg font-semibold text-gray-800">
                                                            {item.seccion.nombre}
                                                        </span>
                                                    </div>
                                                    <Icon.CaretRight
                                                        size={20}
                                                        className={`text-gray-400 transition-transform ${openSubNavMobile === index + 1 ? 'rotate-90' : ''
                                                            }`}
                                                    />
                                                </div>

                                                {/* Submenu expandible */}
                                                {openSubNavMobile === index + 1 && (
                                                    <div className="mt-3 ml-6 space-y-1">
                                                        {(item.seccion.id === 3 ? navPersonalizados : item.subSeccion).map(
                                                            (subseccion: any) => (
                                                                <a
                                                                    key={subseccion.id}
                                                                    href={
                                                                        item.seccion.id === 3
                                                                            ? `/producto/personalizado/${subseccion.nombre}`
                                                                            : `/tienda/${item.seccion.nombre}/${subseccion.nombre}`
                                                                    }
                                                                    className="block px-3 py-2 rounded-lg text-sm transition-all duration-200 text-gray-600 hover:text-[#790546] hover:bg-gray-50"
                                                                >
                                                                    {subseccion.nombre}
                                                                </a>
                                                            )
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Quick Links */}
                            <div className="quick-links px-4 py-6 border-t border-gray-100">
                                <h3 className="text-lg font-semibold text-[#790546] mb-4">Enlaces Rápidos</h3>
                                <div className="grid grid-cols-2 gap-3">
                                    <a href="/nosotros" className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                                        <div className="w-10 h-10 bg-[#790546] rounded-lg flex items-center justify-center">
                                            <span className="text-white font-bold text-sm">N</span>
                                        </div>
                                        <div>
                                            <p className="font-medium text-gray-800">Nosotros</p>
                                            <p className="text-xs text-gray-500">Misión y Visión</p>
                                        </div>
                                    </a>
                                    <a href="/contacto" className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                                        <div className="w-10 h-10 bg-[#790546] rounded-lg flex items-center justify-center">
                                            <span className="text-white font-bold text-sm">C</span>
                                        </div>
                                        <div>
                                            <p className="font-medium text-gray-800">Contacto</p>
                                            <p className="text-xs text-gray-500">Ponte en contacto</p>
                                        </div>
                                    </a>
                                    <a href="/ubicacion" className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                                        <div className="w-10 h-10 bg-[#790546] rounded-lg flex items-center justify-center">
                                            <span className="text-white font-bold text-sm">U</span>
                                        </div>
                                        <div>
                                            <p className="font-medium text-gray-800">Ubicación</p>
                                            <p className="text-xs text-gray-500">Nuestras tiendas</p>
                                        </div>
                                    </a>
                                    <a href="/cotizacion/normal" className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                                        <div className="w-10 h-10 bg-[#790546] rounded-lg flex items-center justify-center">
                                            <span className="text-white font-bold text-sm">Q</span>
                                        </div>
                                        <div>
                                            <p className="font-medium text-gray-800">Cotizaciones</p>
                                            <p className="text-xs text-gray-500">Solicita tu precio</p>
                                        </div>
                                    </a>
                                    <a href="/auth/register" className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                                        <div className="w-10 h-10 bg-[#790546] rounded-lg flex items-center justify-center">
                                            <span className="text-white font-bold text-sm">R</span>
                                        </div>
                                        <div>
                                            <p className="font-medium text-gray-800">Registro</p>
                                            <p className="text-xs text-gray-500">Únete a nosotros</p>
                                        </div>
                                    </a>
                                    <a href="/menus" className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                                        <div className="w-10 h-10 bg-[#790546] rounded-lg flex items-center justify-center">
                                            <span className="text-white font-bold text-sm">M</span>
                                        </div>
                                        <div>
                                            <p className="font-medium text-gray-800">Ver Todos los Menús</p>
                                            <p className="text-xs text-gray-500">Explora nuestros menús</p>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            {/* Login/Perfil Section */}
                            <div className="user-section px-4 py-6 border-t border-gray-100">
                                <h3 className="text-lg font-semibold text-[#790546] mb-4">Mi Cuenta</h3>
                                {user ? (
                                    <div className="space-y-3">
                                        {/* Dropdown del usuario */}
                                        <div className="relative user-dropdown">
                                            <div
                                                className="flex items-center gap-3 p-3 bg-[#790546]/5 rounded-lg cursor-pointer hover:bg-[#790546]/10 transition-colors"
                                                onClick={() => setIsUserDropdownOpen(!isUserDropdownOpen)}
                                            >
                                                <div className="w-10 h-10 bg-[#790546] rounded-full flex items-center justify-center">
                                                    <span className="text-white font-bold text-sm">
                                                        {user.nombre?.charAt(0) || 'U'}
                                                    </span>
                                                </div>
                                                <div className="flex-1">
                                                    <p className="font-medium text-gray-800">{user.nombre}</p>
                                                    <p className="text-xs text-gray-500">{user.correo || user.nombre}</p>
                                                </div>
                                                <Icon.CaretDown
                                                    size={16}
                                                    className={`text-gray-400 transition-transform ${isUserDropdownOpen ? 'rotate-180' : ''}`}
                                                />
                                            </div>

                                            {/* Opciones del dropdown */}
                                            {isUserDropdownOpen && (
                                                <div className="mt-2 space-y-2">
                                                    <a href="/profile" className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                                                        <LuUser2 className="w-5 h-5 text-[#790546]" />
                                                        <div>
                                                            <p className="font-medium text-gray-800">Mi Cuenta</p>
                                                            <p className="text-xs text-gray-500">Ver perfil</p>
                                                        </div>
                                                    </a>
                                                    <a href="/profile/myorders" className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                                                        <Icon.ShoppingBag className="w-5 h-5 text-[#790546]" />
                                                        <div>
                                                            <p className="font-medium text-gray-800">Mis Compras</p>
                                                            <p className="text-xs text-gray-500">Historial de pedidos</p>
                                                        </div>
                                                    </a>
                                                    <a href="/profile/address" className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                                                        <Icon.MapPin className="w-5 h-5 text-[#790546]" />
                                                        <div>
                                                            <p className="font-medium text-gray-800">Mis Direcciones</p>
                                                            <p className="text-xs text-gray-500">Gestionar ubicaciones</p>
                                                        </div>
                                                    </a>
                                                    <a href="/profile/mypoints" className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                                                        <PiHandCoinsThin className="w-5 h-5 text-[#790546]" />
                                                        <div>
                                                            <p className="font-medium text-gray-800">Mis Puntos</p>
                                                            <p className="text-xs text-gray-500">Ver puntos disponibles</p>
                                                        </div>
                                                    </a>
                                                    <button
                                                        onClick={() => {
                                                            // Aquí iría la función de logout
                                                            window.location.href = '/api/auth/logout';
                                                        }}
                                                        className="w-full flex items-center gap-3 p-3 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors font-medium"
                                                    >
                                                        <Icon.SignOut className="w-5 h-5" />
                                                        <div>
                                                            <p className="font-medium">Cerrar Sesión</p>
                                                            <p className="text-xs text-red-500">Salir de la cuenta</p>
                                                        </div>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="space-y-3">
                                        <a
                                            href="/auth/login"
                                            className="block w-full p-3 bg-[#790546] text-white rounded-lg hover:bg-[#6a0440] transition-colors font-medium text-center"
                                        >
                                            Iniciar Sesión
                                        </a>
                                        <a href="/auth/register" className="block w-full p-3 bg-white border-2 border-[#790546] text-[#790546] rounded-lg hover:bg-[#790546]/5 transition-colors font-medium text-center">
                                            Registrarse
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default nav;
